import { render } from "./ProjectPage.vue?vue&type=template&id=04195748&hidden=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jamesedgeworth/Sites/je-vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__